/**
 * Brands Listing Vue Component
 * ------------------------------------------------------------------------------
 * Template in sections/template-brands.liquid
 *
 */

 import axios from 'axios';
 import Collapsible from './collapsible.vue'
 
 import { getBrandsListUrl } from '../utils/api';
 
 const API_URL = getBrandsListUrl();
 const VALID_CATEGORY_KEYS = [ "Glasses Frames", "Contact Lenses", "Sunglasses" ];
 
 export default {
     components: {
         Collapsible,
     },
 
     props: {
         sectionTitles: {
             type: Object
         }
     },
 
     data() {
         return {
             brands: [],
             isLoading: true,
         }
     },
 
     computed: {
     },
 
     watch: {
     },
 
     mounted() {
         this._getBrandsData();
     },
 
     methods: {
 
         // Private
        _generateCollectionUrl(vendor, category) {
            let reformattedVendor = vendor.replaceAll(' ', '-').toLowerCase(),
                reformattedCategory = category.replaceAll(' ', '-').toLowerCase()
            return `/collections/${reformattedVendor}-${reformattedCategory}`;
        },

         _getBrandsData() {
            axios.get(API_URL)
                 .then(({ data }) => {
                    //  console.log(">> DATA", data);
                    this._parseBrandsData(data);
                 }).catch((error) => {
                    console.log(error);
                });
         },
 
         _parseBrandsData(data) {
            // delte the stuff we dont want to show
            let brandsRawData = data;

            Object.keys(brandsRawData).forEach( key => {
                if (!VALID_CATEGORY_KEYS.includes(key)) {
                    delete brandsRawData[key];
                };
            })

            /* 
                Ok this looks gross but its basically outputting all of the brands data into a nice format we can use.
                Using reduce a lot so we can output objects directly.

                - the categories are a lot cleaner than they were originally, which makes our life a lot easier; we can use the category names elsewhere than having to group things ourselves
                - group the vendors in a category alphabetically
                    - generate groups dynamically using object[key]
                    - then transform into happier objects using Object.entries to get the key and data separately

                {
                    category: [
                        {
                            group: alpha-character,
                            data: [
                                { 
                                    vendor: abcd,
                                    count: 123,
                                    url: google.com
                                }
                            ]
                        }
                    ]
                }
            */
            this.brands = Object.entries(brandsRawData).reduce( (acc, category) => {
                let categoryName = category[0],
                    categoryNameFormatted = categoryName.replace(' ', '_').toLowerCase(),
                    vendorsDataGrouped = Object.values(category[1]).reduce( (acc, vendor) => {
                        let alphaKey = vendor.vendor.toLowerCase()[0];
                        return {
                            ...acc,
                            [`${alphaKey}`]: [
                                ...(acc[`${alphaKey}`] || []),
                                {
                                    ...vendor,
                                    url: this._generateCollectionUrl(vendor.vendor, categoryName )
                                }
                            ]
                        }
                    }, {}),
                    vendorsDataFormatted = Object.entries(vendorsDataGrouped).map( dataset => {
                        return {
                            'group': dataset[0], // this is alphaKey from the previous step
                            'data': dataset[1] // array of all the vendor data objects
                        }
                    });
                return {
                    ...acc,
                    [categoryNameFormatted]: vendorsDataFormatted
                }
            }, {});

            this.isLoading = false;
         }
     }
 }